export const batsmanStats = [
    {
      actual_name: "RunsScored",
      display_name: "RS",
    },
    {
      actual_name: "BallsPlayed",
      display_name: "BF",
    },
    {
      actual_name: "FoursHit",
      display_name: "4H",
    },
    {
      actual_name: "SixesHit",
      display_name: "6H",
    },
    {
      actual_name: "Catch",
      display_name: "CT",
    },
    {
      actual_name: "Runout",
      display_name: "RO",
    },
    {
      actual_name: "Dream11ProjectedFantasyPoints",
      display_name: "FP",
    },
  ];
  
  export const bowlerStats = [
    {
      actual_name: "Over",
      display_name: "O",
    },
    {
      actual_name: "RunsGiven",
      display_name: "RG",
    },
    {
      actual_name: "WKTaken",
      display_name: "WK",
    },
    {
      actual_name: "FoursGiven",
      display_name: "4G",
    },
    {
      actual_name: "SixesGiven",
      display_name: "6G",
    },
    {
      actual_name: "Catch",
      display_name: "CT",
    },
    {
      actual_name: "Runout",
      display_name: "RO",
    },
    {
      actual_name: "Dream11ProjectedFantasyPoints",
      display_name: "FP",
    },
  ];
  
  export const allRounder = [
    {
      actual_name: "RunsScored",
      display_name: "RS",
    },
    {
      actual_name: "BallsPlayed",
      display_name: "BF",
    },
    {
      actual_name: "FoursHit",
      display_name: "4H",
    },
    {
      actual_name: "SixesHit",
      display_name: "6H",
    },
    {
      actual_name: "Over",
      display_name: "O",
    },
    {
      actual_name: "RunsGiven",
      display_name: "RG",
    },
    {
      actual_name: "WKTaken",
      display_name: "WK",
    },
    {
      actual_name: "FoursGiven",
      display_name: "4G",
    },
    {
      actual_name: "SixesGiven",
      display_name: "6G",
    },
    {
      actual_name: "Catch",
      display_name: "CT",
    },
    {
      actual_name: "Runout",
      display_name: "RO",
    },
    {
      actual_name: "Dream11ProjectedFantasyPoints",
      display_name: "FP",
    },
  ];
  
  export const wicketKeeper = [
    {
      actual_name: "RunsScored",
      display_name: "RS",
    },
    {
      actual_name: "BallsPlayed",
      display_name: "BF",
    },
    {
      actual_name: "FoursHit",
      display_name: "4H",
    },
    {
      actual_name: "SixesHit",
      display_name: "6H",
    },
    {
      actual_name: "Stumped",
      display_name: "ST",
    },
    {
      actual_name: "Catch",
      display_name: "CT",
    },
    {
      actual_name: "Runout",
      display_name: "RO",
    },
    {
      actual_name: "Dream11ProjectedFantasyPoints",
      display_name: "FP",
    },
  ];